<template>
  <div class="nrbAboutTraining">
    <section class="section">
      <div class="container">
        <h2 class="header-font">FAQ</h2>
        <div class="about_content about_training">
          <Accordion :items="myItems" />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// import VueFaqAccordion from 'vue-faq-accordion'
//import UInput2 from "@/components/core/UInput2";
import Accordion from '@becorps/vue-accordion'
import '../../assets/Faqcustom/custom.css' // import stylesheet

export default {
  name: 'DataScienceFaq',
  components: {
    // //UInput2,
    // VueFaqAccordion,
    Accordion,
  },

  data() {
    return {
      myItems: [
        {
          title: 'What is the duration of the course?\n',
          content: 'The Data Science bootcamp is a 1.5 months long program.\n',
          category: 'FAQ',
        },
        {
          title: 'What is the bootcamp fee?\n',
          content: '10,000BDT Per person',
          category: 'FAQ',
        },
        {
          title: 'What is the mode of payment? \n',
          content: 'We offer Bkash or Bank Payee Check \n',
          category: 'FAQ',
        },
        {
          title: 'Do you need previous data experience? \n',
          content:
            'No, any prerequisites will be shared in the videos and reading materials\n',
          category: 'FAQ',
        },
        {
          title: 'How much do I need to secure to qualify? \n',
          content: '60% of the total score  i.e. 6 out of 10 \n',
          category: 'FAQ',
        },
        {
          title: 'How many times can I take the quiz?\n',
          content:
            'You can take the quiz twice. The highest score will be counted as the final score.',
          category: 'FAQ',
        },
        {
          title: 'What are the materials that will be available?\n',
          content:
            'You’ll get recorded videos and reading materials every week. Hands on Workshops with the instructor himself for 2.5 hours each week.\n',
          category: 'FAQ',
        },
        {
          title: 'Will I have lifetime access to the videos?\n',
          content:
            'Yes, if you get enrolled in the bootcamp, and continue till the certification you will have lifetime access to the videos. \n',
          category: 'FAQ',
        },
        {
          title: 'Do I need to make appointments beforehand with the TA’s?\n',
          content:
            'Yes, you do. They will be available every Thursday night for 1-1.5hours to answer all your queries regarding the weekly content. \n',
          category: 'FAQ',
        },
        {
          title: 'How will the top 5 be assessed?\n',
          content:
            'There will be an assessment test by the end of the bootcamp, and a weekly performance track will also be kept to evaluate each students’ position. \n',
          category: 'FAQ',
        },
        {
          title:
            'Will all the top 5 students get a job at Intelligent Machines?\n',
          content:
            'No, the top 5 students will get a chance to interview at Intelligent Machines whenever a relevant job position is open. They will get the job depending on how they are in the interview.\n',
          category: 'FAQ',
        },
      ],
      clone: [],
    }
  },
  methods: {
    search(e) {
      if (e == '') {
        this.myItems = this.clone
      } else {
        this.myItems = this.clone.filter(
          (o) => o.title.includes(e) || o.value.includes(e)
        )
      }
    },
  },
  created() {
    this.clone = this.myItems
  },
}
</script>
<style scoped>
.header-font {
  font: 800 2.25rem/2.75rem 'Manrope';
  color: #29292b;
}
</style>
